import moment from 'moment';
import modalTemplate from '../../../../../media/views/modals/media-selector-modal.tpl.html';
import AlMediaSelectorModalController from '../../../../../media/controllers/modals/media-selector-modal-controller';
import guestlistDuplicationSettingsTemplate
    from '../../../../views/modals/guestlist-duplication-settings-modal-controller.tpl.html';
import GuestlistDuplicationSettingsModalController
    from '../../../../controllers/modals/guestlist-duplication-settings-modal-controller';
import GuestlistAfterCreateModalController from '../../../../controllers/modals/after-create-modal-controller';
import afterCreateModalTemplate from '../../../../views/modals/after-create-modal.tpl.html';
import guestlistModelReducer from '../../../../../../pages/guestlists/helpers/guestlist-model-reducer';

export default class AlGuestlistGridEntryController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');
        this.userStore = this.injector.get('Users');
        this.uibModal = this.injector.get('$uibModal');
        this.usersStore = this.injector.get('Users');
        this.navHelper = this.injector.get('NavHelper');

        this.guestlist = null;
        this.onTriggerReload = () => {
        };

        this.statusInformation = null;
        this.actions = [];
        this.statLabels = [];

        this.fileSelectionTrigger = null;
        this.landingpageEnabled = false;
    }


    $onInit() {
        this._updateGuestlistInformation();
        this._initWatchers();
    }

    showGuestlist() {
        this.state.go('app.guestlists.rsvps.index', {
            gid: this.guestlist.id
        })
    }

    triggerTeaserImageMediaManager() {
        this._selectTeaserImageFromMediaManager();
    }

    showLandingpage() {
        if (!this.landingpageEnabled) {
            return;
        }

        const extRegDomain = _.get(this.usersStore.state.company, 'settings.lp-api.ext_reg_domain'),
            guestlistFullDomainAndPath = `https://${this.guestlist.guestlist_domain}${this.guestlist.guestlist_path ? '/' + this.guestlist.guestlist_path : ''}`;

        let url;

        if (extRegDomain) {
            if (extRegDomain.match(/GUESTLIST_UID/)) {
                url = extRegDomain.replace('GUESTLIST_UID', this.guestlist.uid);
            } else {
                url = extRegDomain + this.guestlist.uid;
            }
        }

        if (!url) {
            url = guestlistFullDomainAndPath;
        }

        const newWindow = window.open('', '_blank');

        if (_.get(this.userStore, 'state.company.settings.lp-api.studio_used', false)) {
            let studioPageAvailable = false;
            const studioCalls = [];
            _.each(_.get(this.userStore, 'state.company.settings.guestlists.studio_urls', []), (studio) => {
                studioCalls.push(this.api.get(studio.url.concat(`/sites/by-guestlist/${this.guestlist.id}`))
                    .then((response) => {
                        url = guestlistFullDomainAndPath
                        newWindow.location = url
                        studioPageAvailable = true;
                    })
                    .catch(() => {
                    }));
            })

            Promise.all(studioCalls)
                .then(() => {
                    if (!studioPageAvailable) {
                        this.alert.error('Landingpage not available', 'No landing page has been defined for this event yet.');
                    }
                })
            return;
        }

        newWindow.location = url;
    }

    handleTeaserUploadSuccess(uploadedFile) {
        this._updateGuestlistTeaserImage(uploadedFile);
    }

    handleTeaserUploadError() {
        this.alert.error(
            this._getTranslationValue('alerts.teaser_set_error.title'),
            this._getTranslationValue('alerts.teaser_set_error.content')
        );
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.guestlist,
            () => {
                this._updateGuestlistInformation();
            }
        )
    }

    _updateGuestlistInformation() {
        this.statusInformation = null;
        this._prepareStatLabels();

        switch (this.guestlist.status) {
            case 'event_running':
                this.statusInformation = {
                    animation: 'event_running',
                    containerClass: 'guestlist-status-running'
                };
                break;
            case 'event_finished':
                this.statusInformation = {
                    animation: 'event_finished',
                    containerClass: 'guestlist-status-finished'
                };
                break;
            case 'reg_closed':
                this.statusInformation = {
                    animation: 'registration_closed',
                    containerClass: 'guestlist-status-closed'
                };
                break;
            case 'reg_open':
                this.statusInformation = {
                    animation: 'registration_open',
                    containerClass: 'guestlist-status-open'
                };
                break;
        }


        this.actions = [
            {
                label: this._getTranslationValue('actions.edit_settings'),
                action: () => {
                    this.state.go('app.guestlists.rsvps.edit-settings', {
                        gid: this.guestlist.id
                    })
                }
            },
            {
                label: this._getTranslationValue('actions.edit_landingpage'),
                action: () => {
                    this.state.go('app.guestlists.rsvps.edit-landingpage-settings', {
                        gid: this.guestlist.id
                    })
                }
            },
            {
                label: this._getTranslationValue('actions.archive'),
                action: () => {
                    this.api
                        .delete(`guestlists/${this.guestlist.id}`)
                        .then(() => {
                            this.onTriggerReload();
                            this.alert.success(
                                this.translate.instant('general.alerts.archive_success.title'),
                                this.translate.instant('general.alerts.archive_success.content')
                            );
                        })
                        .catch(() => {
                            this.onTriggerReload();
                            this.alert.error(
                                this.translate.instant('general.alerts.archive_error.title'),
                                this.translate.instant('general.alerts.archive_error.content')
                            );
                        })
                }
            },
            {
                label: this._getTranslationValue('actions.copy'),
                action: async () => {
                    let duplicateSettings = null;
                    try {
                        duplicateSettings = await this.uibModal
                            .open({
                                templateUrl: guestlistDuplicationSettingsTemplate,
                                controller: GuestlistDuplicationSettingsModalController,
                                controllerAs: 'vm',
                                resolve: {
                                    showGuestlistParams: () => {
                                        return true;
                                    },
                                    oldGuestlist: () => {
                                        return {
                                            name: this.guestlist.name,
                                            settings: {
                                                start_date: this.guestlist.settings_start_date,
                                                end_date: this.guestlist.settings_end_date
                                            }
                                        };
                                    }
                                }
                            })
                            .result;
                    } catch (e) {
                        console.log(e);
                    }

                    if (!duplicateSettings) {
                        return;
                    }

                    let duplicateResponse = null;
                    try {
                        duplicateResponse = await this.api
                            .post(
                                'guestlists/duplicate',
                                {
                                    ...duplicateSettings,
                                    guestlists: {
                                        filters: [
                                            {
                                                "field": "id",
                                                "operator": "=",
                                                "value": this.guestlist.id
                                            }
                                        ],
                                        count: 1
                                    }
                                }
                            );
                        this.onTriggerReload();
                    } catch (e) {
                        this.alert.handle(e)
                        return;
                    }
                    this.alert.success('Success', 'Guestlist was duplicated');
                    const newGuestlistId = duplicateResponse.data.data.duplicate_information[0].new;
                    this.state.go('app.guestlists.rsvps.index', {gid: newGuestlistId});
                    this.navHelper.updateEventInformation();

                    this.uibModal.open({
                        controller: GuestlistAfterCreateModalController,
                        controllerAs: 'vm',
                        templateUrl: afterCreateModalTemplate,
                        resolve: {
                            guestlist: async () => {
                                const guestlistResponse = await this.api.get(`guestlists/${newGuestlistId}`);

                                return new guestlistModelReducer(guestlistResponse.data.data);
                            }
                        }
                    }).result.then(() => {

                    }, () => {

                    });
                }
            },
            {
                label: this._getTranslationValue('actions.change_preview'),
                action: () => {
                    this._selectTeaserImageFromMediaManager();
                }
            }
        ]

        this.landingpageEnabled = _.get(this.usersStore.state.company, 'settings.lp-api.ext_reg_domain') || this.guestlist.guestlist_path;
    }

    _getTranslationValue(path) {
        return this.translate.instant(`guestlists.components.al-guestlist-grid-view-entry.${path}`);
    }

    _selectTeaserImageFromMediaManager() {
        this.uibModal
            .open({
                templateUrl: modalTemplate,
                size: 'mlg',
                windowClass: 'modal-fixed modal-fixed-media',
                controller: AlMediaSelectorModalController,
                controllerAs: 'vm',
                resolve: {
                    startDirectory: () => {
                        return this.userStore.state.company.media.default_directories.guestlists;
                    },
                    allowedMimes: () => {
                        return ['image/jpeg', 'image/png', 'image/bmp', 'image/gif'];
                    },
                    preSelectedFile: () => {
                        return this.guestlist.teaser_image ? this.guestlist.teaser_image.uuid : null;
                    }
                }
            })
            .result
            .then(({file}) => {
                this._updateGuestlistTeaserImage(file);
                this.scope.$applyAsync();
            })
            .catch((e) => {
            });
    }

    _updateGuestlistTeaserImage(uploadedFile) {
        const oldTeaserImage = _.cloneDeep(this.guestlist.teaser_image);

        this.guestlist.teaser_image = uploadedFile;
        this.api
            .put(
                `guestlists/${this.guestlist.id}/teaser-image`,
                {
                    file_uuid: uploadedFile.uuid
                }
            )
            .then(() => {
                this.alert.success(
                    this._getTranslationValue('alerts.teaser_set_success.title'),
                    this._getTranslationValue('alerts.teaser_set_success.content')
                );
                this.navHelper.updateEventInformation();
            })
            .catch(() => {
                this.guestlist.teaser_image = oldTeaserImage;
                this.alert.error(
                    this._getTranslationValue('alerts.teaser_set_error.title'),
                    this._getTranslationValue('alerts.teaser_set_error.content')
                );
            })
    }

    _prepareStatLabels() {
        const statLabels = [
            {
                label: this._getTranslationValue('stat_labels.confirmed_guests'),
                value: this.guestlist.sum_pax_planned_confirmed || 0
            }
        ];

        switch (this.guestlist.status) {
            case 'reg_closed':
            case 'reg_open':
                statLabels.push({
                    label: this._getTranslationValue('stat_labels.no_feedback_guests'),
                    value: this.guestlist.sum_pax_planned_invited || 0
                });

                statLabels.push({
                    label: this._getTranslationValue('stat_labels.event_start_days'),
                    value: moment(this.guestlist.settings_start_date).diff(moment(), 'days')
                });
                break;
            case 'event_running':
            case 'event_finished':
                statLabels.push({
                    label: this._getTranslationValue('stat_labels.checked_in_guests'),
                    value: this.guestlist.sum_pax_actual || 0
                });

                let noShowRate = 0;

                if (this.guestlist.sum_pax_actual_confirmed <= 0) {
                    if (this.guestlist.sum_pax_planned_confirmed > 0) {
                        noShowRate = 100;
                    }
                } else {
                    noShowRate = (10000 - Math.round(10000 * (this.guestlist.sum_pax_actual_confirmed / this.guestlist.sum_pax_planned_confirmed))) / 100;
                }

                statLabels.push({
                    label: this._getTranslationValue('stat_labels.no_show_rate'),
                    value: noShowRate + ' %'
                });
                break;
        }

        this.statLabels = statLabels;

        /**
         * Registration Open & Registration closed

         Confirmed guests / Guests without feedback / Event starts in (days)

         Event Finished & Event running
         Confirmed guests / Checked-in guests / No-Show Rate
         */

    }
}

AlGuestlistGridEntryController
    .$inject = [
    '$scope',
    '$injector'
]



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlists-grid-view/sub-components/al-guestlist-grid-entry/controller.js